import React, { useEffect } from 'react';
import { useFeatureLimits } from './FeatureLimitsProvider';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import Challenges from '../Challenges';
import { FloatingUsageIndicator } from './FeatureUsageIndicator';
import { Alert, Button } from 'react-bootstrap';
import { FaCrown, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SideNavbar from '../helpers/SideNavbar';
import { validateProfileComplete } from '../../utils/profileValidation';

// Smart wrapper that allows viewing existing challenges even when limit is reached
const ChallengesWithSmartLimits = () => {
  const navigate = useNavigate();

  // Check profile completion on component mount
  useEffect(() => {
    if (!validateProfileComplete({ showAlert: true, navigate })) {
      // Profile is incomplete - alert already shown by validateProfileComplete
      // If user clicks "Go to Profile Hub", they will be redirected
    }
  }, [navigate]);
  const {
    hasReachedLimit,
    getFeatureLimit,
    isFreeUser,
    isSubscriber
  } = useFeatureLimits();

  const isLimitReached = hasReachedLimit(FEATURE_NAMES.CHALLENGES);
  const limit = getFeatureLimit(FEATURE_NAMES.CHALLENGES);
  const isBlocked = limit && limit.limit_value === 0;

  // If completely blocked (free users), show the access denied page with sidebar
  if (isBlocked) {
    return (
      <div className="">
        <SideNavbar>
          <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
            <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
              <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>
                Knack Challenges
              </h5>
              <hr />
            </div>
            <div className="card-body text-center p-4">
              <div className="mb-3">
                <FaCrown className="text-danger" style={{ fontSize: '3rem' }} />
              </div>
              <h5 className="mb-3">Feature Not Available</h5>
              <p className="text-muted mb-4">
                Challenges are not available for free users. Please upgrade to access this feature.
              </p>
              
              <div className="row mb-4">
                <div className="col-12 col-md-8 offset-md-2">
                  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                    <iframe
                      width="100%"
                      height="100%"
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      src="https://www.youtube.com/embed/fjSupgaMYyE"
                      title="Knack Challenges Tutorial Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={() => navigate('/feature-limits')}
                  className="me-2"
                >
                  View Limits
                </Button>
                <Button 
                  variant="success" 
                  size="lg"
                  onClick={() => navigate('/subscription')}
                  className="me-2"
                >
                  <FaCrown className="me-2" />
                  Upgrade
                </Button>
              </div>
            </div>
          </div>
        </SideNavbar>
      </div>
    );
  }

  // If limit is reached but not blocked, show challenges with subtle indicators
  return (
    <div>
      <FloatingUsageIndicator 
        featureName={FEATURE_NAMES.CHALLENGES} 
        position="top-right" 
      />
      
      <Challenges 
        isLimitReached={isLimitReached} 
        limitInfo={{ limit, navigate }}
      />
    </div>
  );
};

export default ChallengesWithSmartLimits;
